import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Games from './Games';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/games" element={<Games />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
